import React, { useState, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';
import { FaRegClock } from 'react-icons/fa';
import _ from 'lodash';
import i18n from 'i18next';

import { getMealState } from '../../../store/meals/selector';
import {
  MealCardsParams,
  getScheduleTime,
} from '../../dashboard/components/MealCarousel';
import { AddMealButton } from './AddMealButton';
import { ScheduleProps } from '../AddMeals';

export interface TimeDetailProps {
  schedule: ScheduleProps[];
}

export const TimeDetail: React.FC<TimeDetailProps> = ({ schedule }) => {
  const getFirstSchedule = _.head(schedule);
  const getFirstScheduleTime = _.head(getFirstSchedule?.time);
  const time = getScheduleTime(getFirstScheduleTime);
  return (
    <Col className="time-details" span={22}>
      {schedule.length > 0 ? <FaRegClock size={15} color="#939393" /> : null}
      {schedule.length > 0 ? <span>{time}</span> : i18n.t('CONSTANT_OFFER')}
    </Col>
  );
};

export const MealItem: React.FC<MealCardsParams> = ({ meal }) => {
  return (
    <Col className="list-container">
      <TimeDetail schedule={meal.schedule} />
      <Link to={`mymeals/${meal.id}`}>
        <Col
          span={22}
          className="meal-wrapper"
          style={{
            backgroundImage: `url(${meal.image})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="meal-description">
            <div className="description">{meal.title}</div>
            {/* <div className="meal-price">{`Kč ${Number(meal.price).toFixed(
              2
            )}`}</div> */}
          </div>

          <div className="overlay"></div>
        </Col>
      </Link>
    </Col>
  );
};

export const MealList: React.FC = () => {
  const { meals } = useSelector(getMealState);
  const [width, setWidth] = useState<number>(0);
  useLayoutEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  const isDesktop = width >= 768;
  return (
    <Row justify="center" className="orders-container">
      <Col xs={24} sm={24} md={24} lg={24} className="orders-inner">
        <div className={isDesktop ? 'grid-display' : ''}>
          {meals.map((item, i) => (
            <div key={i}>
              <MealItem meal={item} />
            </div>
          ))}
        </div>
        <AddMealButton />
      </Col>
    </Row>
  );
};
